import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a1e5a26afefc00014aefb99_1780385126328/drivetheory/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a1e5a26afefc00014aefb99_1780385126328/drivetheory/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a1e5a26afefc00014aefb99_1780385126328/drivetheory/src/app/components/HeroSection.tsx");
